// Save a blob the API returned as a local file download. Used wherever the
// backend streams a document behind the JWT (the token travels in the
// Authorization header, so plain <a href> downloads are not an option).
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
